import loginTemplate from './login.html';
import loginController from './login.controller';
import './login.scss';
// import satellizer from 'satellizer';
// import Config from '../../app.config';

let module = angular.module('login', [
	'ionic',
	'satellizer',
	'app.config'
])
.run(function(
	$auth,
	$state,
	$rootScope,
	Customer,
	$filter,
	$location
) {
	"ngInject";

	$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
		if(!$auth.isAuthenticated() && (toState.name !== 'password' && toState.name !== 'login')) {
			$location.path('/login');
		}
	});

})
.config(($stateProvider, $urlRouterProvider, $authProvider, config) => {
	"ngInject";

	$authProvider.loginUrl = config.api + '/v1/authenticate';

	$stateProvider
		.state('login', {
			url: '/login',
			template: loginTemplate,
			controller: loginController,
			controllerAs: 'login',
			resolve: {
				language: Language => Language.translations()
			}
		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/login/login.js